var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { EXTRA_LARGE_CLASS, useClassNames, useElementWidth, } from '../../util/screen';
var HeroContainer = styled.div((_a = {
        display: 'flex',
        justifyContent: 'center',
        borderBottom: '1px solid #d8d8d8'
    },
    _a["&.".concat(EXTRA_LARGE_CLASS)] = {
        borderBottom: 'none',
    },
    _a));
var HeroContent = styled.div({
    width: '100%',
    maxWidth: '1360px',
});
var Title = styled.h1({
    fontFamily: 'var(--font-family-secondary)',
    fontSize: '2em',
});
var ContentContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
});
var Content = styled.div({
    width: '100%',
    maxWidth: '1200px',
});
var RecipesListContainer = styled.div({
    marginTop: '24px',
});
export var RecipesExplorer = function (_a) {
    var hero = _a.hero, filters = _a.filters, recipesList = _a.recipesList;
    var _b = useElementWidth(), ref = _b.ref, width = _b.width;
    var className = useClassNames(width);
    return (_jsxs("div", __assign({ ref: ref }, { children: [hero && (_jsx(HeroContainer, __assign({ className: className }, { children: _jsx(HeroContent, { children: hero }, void 0) }), void 0)), _jsx(ContentContainer, { children: _jsxs(Content, { children: [_jsx(Title, { children: "All recipes" }, void 0), filters, _jsx(RecipesListContainer, { children: recipesList }, void 0)] }, void 0) }, void 0)] }), void 0));
};
